import { CrmEndpointModuleConfig } from '@touch4it/ng-swp/endpoint';

import { environment } from '../../environments/environment';

export const endpointConfig: CrmEndpointModuleConfig = {
  endpoints: [
    {
      name: 'crm',
      baseUrl: environment.serverUrl,
      withCredentials: true,
      httpHeaders: { Authorization: `Basic ${environment.basicAuth}` },
    },
  ],
};
